import { render, staticRenderFns } from "./AssignmentForm.vue?vue&type=template&id=b24a0e58&"
import script from "./AssignmentForm.vue?vue&type=script&lang=ts&"
export * from "./AssignmentForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports